import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'components/Dropdown';

const TestSelectionComponent = props =>
  <div className="main-dropdown mb-20">
    <p className="main-dropdown__label">
      Test Parameter
    </p>

    <Dropdown
      isDisabled
      id={props.id}
      value={props.value}
      options={props.options}
      placeholder="Select a Test Parameter"
    />
  </div>;

TestSelectionComponent.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired
};

export default TestSelectionComponent;
